import envConfig from '@acre/config'

import createAxiosInstance from '../utils/createAxiosInstance'

const axiosInstance = createAxiosInstance(
  {
    baseURL: envConfig.PROTECTION_API_V2_URL,
  },
  {
    useApiKey: true,
  },
)

export default axiosInstance
